import { Flex } from 'rebass/styled-components';

import { rem } from '@blueprint/ui';

import { SystemNotification, ButtonIcon } from 'components/blueprint';
import { useSafeLabel } from 'hooks';
import { useSetIsSupportPanelOpen } from 'state/isSupportPanelOpen';

import messages from './messages';

/**
 * SystemErrorNotification
 * Show and Hide this component on the error in api
 */
export const SystemErrorNotification = ({ message }) => {
  const safeLabel = useSafeLabel();

  const setIsSupportPanelOpened = useSetIsSupportPanelOpen();
  const handleClosingSupportPanel = () => setIsSupportPanelOpened(false);

  return (
    <Flex flexDirection="column" width="100%" marginBottom={rem(20)}>
      <ButtonIcon
        name="Close"
        iconProps={{
          titleAccess: safeLabel(messages.buttonTitle),
        }}
        titleAccess={safeLabel(messages.buttonTitle)}
        onClick={handleClosingSupportPanel}
        aria-label={safeLabel(messages.hideAriaLabel)}
        marginLeft="auto"
        marginBottom={rem(10)}
      />

      <SystemNotification role="alert" variant="error" isRemovable={false}>
        {message}
      </SystemNotification>
    </Flex>
  );
};
